import type ArticleLocal from "~/libs/interfaces/ArticleLocal";
import type { Article } from "~/graphql/__generated__/graphql";
import { useHtmlToPlainText } from "~/composables/useHtmlToPlainText";

const articleLocalFactory = {
  createArticleLocalFromArticle(article: Article): ArticleLocal {
    const author = article?.authorList?.edges?.at(0)?.node;
    return {
      ...article,
      ...(author && {
        simpleAuthor: {
          id: author.id as string,
          name: author.fullname as string,
          ...(author.imageAsset?.urlWithProtocol && {
            imageUrlWithProtocol: author.imageAsset?.urlWithProtocol as string
          }),
        },
      }),
      isVisible: true,
      ...(article.published && {
        publishedDate: new Date(article.published)
      }),
      ...(article.jsonBody && {
        jsonBodyDecoded: JSON.parse(article.jsonBody)
      }),
      ...(article.body && {
        bodyPlain: useHtmlToPlainText(article.body)
      }),
      ...(article.rating && {
        ratingDecoded: JSON.parse(article.rating)
      }),
    };
  }
};
export default articleLocalFactory;
